import React,{Component} from 'react'
import { connect } from 'react-redux';

import ValidationOverlay from './validationOverlay.jsx';
import Select from 'react-select';
import Dialog from '../../../commonModules/interface/Dialog';
import Notif from '../../../commonModules/interface/Notif';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Grid ,Typography} from '@material-ui/core';
import { InputSelectMagasin } from '../../../commonModules/interface/form-input-inline.jsx';
import { Alert } from '@material-ui/lab';

class ChangeStatusBox extends Component {
    state = {
        boxList:[],
        boxStatus:{value:"", label:""},
        boxID:{value:"", label:""},
        errors:{
            boxStatus:"",
            boxID:"",
        },
        notif:{
            title:"", 
            type: "", 
            message:"",
            show:false
        },
        msg: "",
        collapse: 2,
    }
    componentDidMount=() => {
        this.getBoxList()
    }
    getBoxList = async () => {
        try{
            let res = await fetch('/association/change/list',{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
    
            })
            const list = await res.json();
            console.log('[INFO], getBoxList, respnse')
            console.log({list});
            if(!list.errorCode){
                let boxes = []
                list.content.map( box => {
                    boxes.push({
                        value:box[1].boxAssoId, label: `${box[1].boxId} - ${box[1].clientName} `
                    })
                })
                this.setState({
                    boxList:boxes
                })
            } else {
                this.setState({
                    boxList:[{value:"", label:""}]
                })
            }
        } catch (error) {
            console.log('[ERROR], getBoxList, error, info')
            console.log(error);
        }
    }
    
    handleChange = (e) =>{
        let value = e.target.value
        let name = e.target.name
        this.setState({
            [name]: value
        })
    }
    handleChange2 = (boxStatus) => {
        this.setState({ boxStatus });
        console.log(`Option selected:`, boxStatus);
      }
    validate = () =>{
        let noErrors = true
        let errors = {}
        const fields = ["boxID", "boxStatus"]
        fields.map(field =>{
            if (this.state[field].value === ""){
                errors[field] = 'Veuillez remplir ce champ'
                noErrors = false
            } else {
                errors[field]= ''
            }
        })
                    
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors, errors});
        
        return noErrors
    }
    handleSubmit = async () =>{
        if(this.validate()){
            let data = {}
            data.boxAssoId = this.state.boxID.value
            data.status = this.state.boxStatus.value

            try {
                let req = await fetch('/box/changeStatus',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify(data),
                    credentials: 'same-origin',
            
                })
                const res = await req.json()
                console.log({res});
                if(!res.error){
                    this.clearForms()
                    this.notif("success", "Statut Mis à Jour" , "Sucess")
                    let timer = setTimeout(() => {
                        this.props.onCloseOverlay()
                      }, 1500);
                } else {
                    console.log({res});
                    this.notif("danger", res.error.message , "Erreur")
                    
                }
            } catch (error) {
                this.notif("danger", error, "Erreur")
            }
        } else {
            this.notif(
                "danger",
                "Le formulaire contient des erreurs",
                "Erreur"
            )
        }
    }
    notif = (type, msg, title = null) => {
        this.setState({
            notif: {
                title:title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    clearForms = () => {
        this.setState({
            boxStatus:{value:"", label:""},
            boxID:{value:"", label:""},
            errors:{
                boxStatus:"",
                boxID:"",
            },
            notif:{
                title:"", 
                type: "", 
                message:"",
                show:false
            },
        })
    }
    render(){
        const { boxList } = this.state
        
        console.log("[STATE] paygo new User", this.state, this.state.boxList);
        
        return(
                <PopUp
                    title="Modifier le statut d'une Box"
                    submitAction={this.handleSubmit}
                    close={this.props.onCloseOverlay}
                    maxWidth="sm"
                >

                    {/* MOVE TO PARENT COMPONENT */}
                    <Notif
                        show={this.state.notif.show} 
                        title={this.state.notif.title} 
                        type={this.state.notif.type} 
                        message={this.state.notif.message} 
                        close={()=> this.setState({
                            notif:{
                                ...this.state.notif,
                                show:false,
                            }
                        })} 
                    />
                    {/* MOVE TO PARENT COMPONENT */}
                    {/* <form> */}
                        <Grid container spacing={2} >
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    label="ID Box"  
                                    value={this.state.boxID}
                                    onChange={(option) => this.setState({boxID:option})}
                                    options={boxList}
                                    helperText={this.state.errors.boxID}
                                />
                            </Grid>                                                
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    label="Statut Box"  
                                    value={this.state.boxStatus}
                                    onChange={(option)=>this.setState({boxStatus:option})}
                                    options={[
                                        {value:"DEMO", label:"Box Demo"},
                                        {value:"REMOVED", label:"Box Retirée"},
                                        {value:"REAFFECTED", label:"Box Reaffectée"},
                                    ]}
                                    helperText={this.state.errors.boxStatus}
                                />
                            </Grid>
                        </Grid>
                        { this.state.boxStatus.value == "REMOVED"  &&
                            <Alert severity="error">
                                Avez-vous pensez à récupérer les stocks du client ? Et à faire un retour de stock dans le magasin d'OCCASION?
                            </Alert>
                        // <Typography variant="h6" style={{
                        //     color: "#FF0000",
                        //     fontWeight: "bold"
                        //     }}
                        // >
                        // </Typography>
                        }
                    {/* </form> */}
                </PopUp>

        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients
    }
}

export default connect(mapStateToProps)(ChangeStatusBox);
